const variable = {
  primaryColor: '#5514B4',
  primaryColorHighlight: 'rgba(0, 82, 142, 0.4)',
  primaryColorHighlightSolid: 'rgb(153, 186, 210)',
  callBtnColor: '#5fb95c',
  smsBubbleBackgroundColor: '#e5edf3',
  brandFontColor: '#5514B4',
  brandFontColorHighlight: 'rgba(0, 82, 142, 0.4)',

  c2dArrowColor: '#5514B4',
  addMeetingBtnColor: '#5514B4',
  addMeetingBtnTextColor: '#FFFFFF',
};

export default variable;
